<app-dialog-header [title]="dialogTitle" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24 pb-0" fxLayout="column" fxLayoutAlign="start">
    <div class="social-list" fxLayoutAlign="space-between center" *ngIf="isSocialListVisible">
        <img src="assets/icons/facebook-social.png" alt="Facebook" />
        <img src="assets/icons/linkedin-social.png" alt="LinkedIn" />
        <img src="assets/icons/xing-social.png" alt="Xing" />
        <img src="assets/icons/x-social.png" alt="X" />
        <img src="assets/icons/instagram-social.png" alt="Instagram" />
        <img src="assets/icons/tiktok-social.png" alt="TikTok" />
    </div>
    <p class="basic-text mb-24 mt-8" *ngIf="label">{{ label }}</p>
    <mat-form-field>
        <mat-label>{{ placeholder | translate }}</mat-label>
        <input matInput appAutofocus noWhitespace [formControl]="nameCtrl" (keydown.enter)="save.emit(nameCtrl.value)" />
        <!-- we're hiding FormControl 'required' error and showing API errors -->
        <mat-error *ngIf="nameCtrl.hasError('email')">
            {{ 'ERROR.RESPONSE.value_invalid_email' | translate }}
        </mat-error>

        <mat-error *ngIf="nameCtrl.errors?.message && !nameCtrl.hasError('required') && !nameCtrl.hasError('email')">
            {{ 'ERROR.RESPONSE.' + nameCtrl.errors['message'] | translate }}
        </mat-error>
    </mat-form-field>
</div>
<div mat-dialog-actions class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
    <div class="button-container">
        <div class="spinner-container" *ngIf="showSpinner">
            <mat-spinner diameter="24"></mat-spinner>
        </div>

        <app-flat-button [label]="buttonLabel" (onClick)="save.emit(nameCtrl.value.trim())" [disabled]="!nameCtrl.valid || showSpinner || !nameCtrl.dirty"></app-flat-button>
    </div>
</div>
